import React from 'react';
import { useDragLayer } from "react-dnd";
import "./DragPreview.scss"
const DragPreview = () => {
  const { itemType, isDragging, currentOffset, item } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getClientOffset(),
  }));

  if (!isDragging || !currentOffset) {
    return null;
  }

  const transform = `translate(${currentOffset.x}px, ${currentOffset.y}px)`;

  return (
    <div style={{
      position: 'fixed',
      pointerEvents: 'none',
      top: 0,
      left: 0,
      zIndex:2000,
      transform,
      WebkitTransform: transform,
    }}>
      <div className='dragPreview'>
        {item.task.roNumber}
      </div>
    </div>
  );
};

export default DragPreview;
